import { render, staticRenderFns } from "./CampaignReach.vue?vue&type=template&id=8ed655c4&scoped=true&"
import script from "./CampaignReach.vue?vue&type=script&lang=js&"
export * from "./CampaignReach.vue?vue&type=script&lang=js&"
import style0 from "./CampaignReach.vue?vue&type=style&index=0&id=8ed655c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed655c4",
  null
  
)

export default component.exports